<script lang="ts" setup></script>

<template>
  <ClientOnly>
    <div
      class="flex flex-col justify-center items-center w-full h-full text-[40px]"
    >
      <icon name="svg-spinners:ring-resize" class="text-primary" />
    </div>
  </ClientOnly>
</template>

<style></style>
